module.exports = __webpack_public_path__ + "img/JunchengMu.499dba36.jpg";